import React from 'react';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../breadcrumb/BreadcrumbOne';
import SectionTitle from '../sectionTitle/SectionTitle';
import { slugify } from '../../utils';
import locales from '../../locales/locales';
import IndustriesScrollAnimation from '../service/IndustriesScrollAnimation';
import CustomIndustry from './CustomIndustry';
import ClientsBrand from '../brand/ClientsBrand';

const Industries = ({
  match: {
    params: { slug },
  },
}) => {
  const {
    INDUSTRIES_ENUMERATION,
    INDUSTRIES_HEADER_TITLE,
    INDUSTRIES_HEADER_TEXT,
  } = locales;
  const data = INDUSTRIES_ENUMERATION.map((industry) => {
    if (!industry.route) {
      return industry;
    }

    return {
      ...industry,
      expectedeIndustry: slugify(industry.route) === slug,
    };
  }).filter((industry) => industry.expectedeIndustry)[0];
  const industryTitle = data && data.title;

  if (industryTitle) {
    return <CustomIndustry data={data} />;
  }

  return (
    <>
      <SEO title="Industries" />
      <Layout>
        <BreadcrumbOne
          title="Industries"
          rootUrl="/"
          parentUrl="Home"
          currentUrl="Industries"
        />
        <div className="main-content">
          {/* Start Service Area  */}
          <div className="rn-service-area rn-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <SectionTitle
                    textAlign="text-center"
                    radiusRounded=""
                    subtitle=""
                    title={INDUSTRIES_HEADER_TITLE}
                    description={INDUSTRIES_HEADER_TEXT}
                  />
                </div>
              </div>
              <IndustriesScrollAnimation
                serviceStyle="service__style--1 bg-color-blackest radius mt--25"
                textAlign="text-center"
              />
            </div>
          </div>
          {/* End Service Area  */}
          <div className="rwt-brand-area rn-section-gap">
            <ClientsBrand brandStyle="brand-style-2 justify-content-evenly" />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Industries;
